import { Modal } from "antd";
import React, { ReactNode, useCallback, useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { WrapperStore } from "../../../..";
import { getParentEl, propsModal } from "../../../../util/varibles/constants";
import ConfigAnt from "../../../Theme/ConfigAnt";
import Header from "../Header";
import styles from "./style.module.scss";

export function openPopup(children: ReactNode, Wrapper = WrapperStore): HTMLDivElement {
    const el = document.createElement('div');
    const root = ReactDOM.createRoot(el as HTMLElement);
    root.render(<Wrapper>{children}</Wrapper>);
    const container = getParentEl();
    container.append(el);
    return el;
}

interface IProps {
    visible?: boolean
    width?: number
    title?: string | ReactNode
    radius?: number | string
    style?: any
    className?: string
    destroyOnHidden?: boolean
    children?: ReactNode
    zIndex?: number

    onClose?(): void
}

const WrapperPopup: React.FC<IProps> = (props) => {
    const [visible, setVisible] = useState(props.visible);
    const style: any = props.style || {};
    const { destroyOnHidden = true, onClose } = props;

    useEffect(() => setVisible(props.visible), [props.visible]);

    const handleClose = useCallback(() => {
        setVisible(false);
        setTimeout(() => onClose?.(), 300);
    }, [onClose])

    if (props.radius) {
        style['--radius'] = props.radius
    }

    return <ConfigAnt>
        <Modal
            {...propsModal}
            width={props.width}
            style={style}
            className={[styles.popup, props.className].join(' ')}
            open={visible}
            title={<Header title={props.title} onClose={handleClose} />}
            mask={{ closable: true }}
            destroyOnHidden={destroyOnHidden}
            onCancel={handleClose}
            zIndex={props.zIndex}
        >
            {props.children}
        </Modal>
    </ConfigAnt>;
};

export default WrapperPopup;
